/**
 * Diagnox Product Hero — gallery, ghost/Lottie animation, variants, add to cart
 */
(function () {
  var SECTION_TYPE = 'diagnox-product-hero';
  var LOTTIE_POLL_MS = 80;
  var LOTTIE_POLL_MAX = 60;
  var galleryVideoPageBound = false;

  function isAmbientVideo(video) {
    if (!video || video.tagName !== 'VIDEO') return true;
    if (video.hasAttribute('data-video-ambient')) return true;
    if (video.hasAttribute('data-dph-gallery-video')) return false;
    return !!(video.autoplay && video.muted && video.loop);
  }

  function forEachHeroGallery(callback) {
    document.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(function (root) {
      var hero = root._dphHero;
      var slidesEl = hero && hero._dphSlidesEl;
      if (!hero || !slidesEl) return;
      callback(hero, slidesEl);
    });
  }

  function bindGalleryVideoPageListeners() {
    if (galleryVideoPageBound) return;
    galleryVideoPageBound = true;

    document.addEventListener('visibilitychange', function () {
      forEachHeroGallery(function (hero, slidesEl) {
        if (document.visibilityState === 'hidden') {
          hero.pauseSlideVideos(slidesEl);
        } else {
          hero.syncSlideVideos(slidesEl, hero._dphSlideIndex || 0);
        }
      });
    });

    window.addEventListener('pagehide', function () {
      forEachHeroGallery(function (hero, slidesEl) {
        hero.pauseSlideVideos(slidesEl);
      });
    });

    // Pause gallery videos when another non-ambient section video starts.
    document.addEventListener(
      'play',
      function (evt) {
        var target = evt.target;
        if (!target || target.tagName !== 'VIDEO') return;
        if (target.hasAttribute('data-dph-gallery-video')) return;
        if (isAmbientVideo(target)) return;

        forEachHeroGallery(function (hero, slidesEl) {
          if (slidesEl.contains(target)) return;
          hero.pauseSlideVideos(slidesEl);
        });
      },
      true
    );
  }

  function DiagnoxProductHero(container) {
    this.container = container;
    this.sectionId = container.getAttribute('data-section-id');
    this.init();
  }

  DiagnoxProductHero.prototype = {
    init: function () {
      this.initGallery();
      this.initAnimation();
      this.initQuantity();
      this.initVariants();
      this.initForm();
    },

    initAnimation: function () {
      var type = this.container.getAttribute('data-animation-type');
      if (type === 'lottie') {
        var cardUrl = this.container.getAttribute('data-lottie-url-card');
        var overlayUrl = this.container.getAttribute('data-lottie-url');
        if (cardUrl) {
          this.initLottieTarget('[data-dph-lottie-card]', cardUrl);
        }
        if (overlayUrl) {
          this.initLottieTarget('[data-dph-lottie]', overlayUrl);
        }
      }
    },

    initLottieTarget: function (selector, url) {
      var lottieEl = this.container.querySelector(selector);
      if (!lottieEl || !url) return;

      var self = this;
      var attempts = 0;

      function tryLoad() {
        if (typeof lottie !== 'undefined') {
          self.loadLottieAnimation(lottieEl, url);
          return;
        }
        attempts += 1;
        if (attempts < LOTTIE_POLL_MAX) {
          setTimeout(tryLoad, LOTTIE_POLL_MS);
        } else {
          console.warn('[Diagnox product hero] Lottie library did not load.');
        }
      }

      tryLoad();
    },

    initGallery: function () {
      var slidesEl = this.container.querySelector('[data-dph-slides]');
      var dots = this.container.querySelectorAll('[data-dph-dot]');
      var prevBtn = this.container.querySelector('[data-dph-prev]');
      var nextBtn = this.container.querySelector('[data-dph-next]');
      if (!slidesEl) return;

      this.initDragScroll(slidesEl);
      this.initSlideVideos(slidesEl);

      var slideCount = slidesEl.children.length;
      var self = this;
      var currentIndex = 0;

      var setActive = function (index) {
        currentIndex = index;
        self._dphSlideIndex = index;
        dots.forEach(function (dot, i) {
          var active = i === index;
          dot.classList.toggle('is-active', active);
          dot.setAttribute('aria-selected', active ? 'true' : 'false');
        });
        self.syncSlideVideos(slidesEl, index);
      };

      // Single-slide galleries still need video sync (handled in initSlideVideos).
      if (slideCount < 2) return;

      var goTo = function (index) {
        if (index < 0) index = slideCount - 1;
        if (index >= slideCount) index = 0;
        var slide = slidesEl.children[index];
        if (!slide) return;
        slidesEl.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        setActive(index);
      };

      dots.forEach(function (dot, index) {
        dot.addEventListener('click', function () {
          goTo(index);
        });
      });

      if (prevBtn) {
        prevBtn.addEventListener('click', function (evt) {
          evt.preventDefault();
          goTo(currentIndex - 1);
        });
      }

      if (nextBtn) {
        nextBtn.addEventListener('click', function (evt) {
          evt.preventDefault();
          goTo(currentIndex + 1);
        });
      }

      var scrollTimer;
      slidesEl.addEventListener(
        'scroll',
        function () {
          clearTimeout(scrollTimer);
          scrollTimer = setTimeout(function () {
            var index = Math.round(slidesEl.scrollLeft / Math.max(slidesEl.offsetWidth, 1));
            index = Math.max(0, Math.min(slideCount - 1, index));
            setActive(index);
          }, 80);
        },
        { passive: true }
      );
    },

    getSlideVideos: function (slidesEl) {
      return slidesEl.querySelectorAll('video');
    },

    pauseSlideVideos: function (slidesEl) {
      this.getSlideVideos(slidesEl).forEach(function (video) {
        try {
          video.pause();
        } catch (e) {
          // ignore
        }
      });
    },

    playSlideVideo: function (video) {
      if (!video) return;

      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.playsInline = true;
      video.setAttribute('playsinline', '');
      video.loop = true;

      // Already playing — avoid restarting on every scroll sync.
      if (!video.paused && !video.ended) return;

      var tryPlay = function () {
        if (!video.paused && !video.ended) return;
        var playPromise = video.play();
        if (playPromise && typeof playPromise.catch === 'function') {
          playPromise.catch(function () {
            var onReady = function () {
              video.removeEventListener('loadeddata', onReady);
              video.removeEventListener('canplay', onReady);
              if (video.paused) {
                video.play().catch(function () {});
              }
            };
            video.addEventListener('loadeddata', onReady);
            video.addEventListener('canplay', onReady);
          });
        }
      };

      if (video.readyState >= 2) {
        tryPlay();
        return;
      }

      var onCanPlay = function () {
        video.removeEventListener('loadeddata', onCanPlay);
        video.removeEventListener('canplay', onCanPlay);
        tryPlay();
      };
      video.addEventListener('loadeddata', onCanPlay);
      video.addEventListener('canplay', onCanPlay);
      tryPlay();
    },

    syncSlideVideos: function (slidesEl, activeIndex) {
      if (!slidesEl) return;
      if (typeof activeIndex !== 'number') {
        activeIndex = this._dphSlideIndex || 0;
      }

      if (document.visibilityState === 'hidden' || this._dphSectionInView === false) {
        this.pauseSlideVideos(slidesEl);
        return;
      }

      Array.prototype.forEach.call(
        slidesEl.children,
        function (slide, index) {
          var video = slide.querySelector('video');
          if (!video) return;
          if (index === activeIndex) {
            this.playSlideVideo(video);
          } else {
            try {
              video.pause();
            } catch (e) {
              // ignore
            }
          }
        }.bind(this)
      );
    },

    initSectionVisibility: function (slidesEl) {
      var self = this;
      this._dphSectionInView = true;

      if (typeof IntersectionObserver !== 'function') {
        this.syncSlideVideos(slidesEl, this._dphSlideIndex || 0);
        return;
      }

      if (this._dphVisibilityObserver) {
        this._dphVisibilityObserver.disconnect();
      }

      this._dphVisibilityObserver = new IntersectionObserver(
        function (entries) {
          var entry = entries && entries[0];
          if (!entry) return;

          var inView = entry.isIntersecting && entry.intersectionRatio > 0;
          if (inView === self._dphSectionInView) return;

          self._dphSectionInView = inView;
          if (inView) {
            self.syncSlideVideos(slidesEl, self._dphSlideIndex || 0);
          } else {
            self.pauseSlideVideos(slidesEl);
          }
        },
        { root: null, threshold: [0, 0.05, 0.15, 0.25], rootMargin: '0px' }
      );

      this._dphVisibilityObserver.observe(this.container);
    },

    initSlideVideos: function (slidesEl) {
      var videos = this.getSlideVideos(slidesEl);
      if (!videos.length) return;

      this._dphSlidesEl = slidesEl;
      this._dphSlideIndex = 0;

      videos.forEach(function (video) {
        var slide = video.closest('[data-dph-slide]');
        var slideIndex = slide
          ? Array.prototype.indexOf.call(slidesEl.children, slide)
          : -1;
        var isActive = slideIndex === 0;

        video.setAttribute('data-dph-gallery-video', '');
        video.setAttribute('playsinline', '');
        video.setAttribute('webkit-playsinline', '');
        video.playsInline = true;
        video.muted = true;
        video.defaultMuted = true;
        video.setAttribute('muted', '');
        video.loop = true;

        try {
          video.preload = isActive ? 'auto' : 'metadata';
          video.setAttribute('preload', isActive ? 'auto' : 'metadata');
        } catch (e) {
          // ignore
        }

        if (isActive) {
          video.autoplay = true;
          video.setAttribute('autoplay', '');
        } else {
          video.autoplay = false;
          video.removeAttribute('autoplay');
          try {
            video.pause();
          } catch (err) {
            // ignore
          }
        }
      });

      bindGalleryVideoPageListeners();
      this.initSectionVisibility(slidesEl);
      this.syncSlideVideos(slidesEl, 0);
    },

    initDragScroll: function (el) {
      // Desktop: allow mouse drag to scroll like mobile swipe.
      // Uses Pointer Events so it works for mouse + touch consistently.
      var isDown = false;
      var startX = 0;
      var startScrollLeft = 0;
      var moved = false;
      var pointerId = null;
      var prevScrollBehavior = '';

      var onPointerDown = function (evt) {
        // Only left click for mouse
        if (evt.pointerType === 'mouse' && evt.button !== 0) return;

        isDown = true;
        moved = false;
        pointerId = evt.pointerId;
        startX = evt.clientX;
        startScrollLeft = el.scrollLeft;
        el.classList.add('is-dragging');
        prevScrollBehavior = el.style.scrollBehavior;
        el.style.scrollBehavior = 'auto';

        try {
          el.setPointerCapture(pointerId);
        } catch (e) {
          // ignore
        }
      };

      var onPointerMove = function (evt) {
        if (!isDown) return;
        // Prevent text/image selection while dragging
        evt.preventDefault();
        var dx = evt.clientX - startX;
        if (Math.abs(dx) > 3) moved = true;
        el.scrollLeft = startScrollLeft - dx;
      };

      var endDrag = function () {
        if (!isDown) return;
        isDown = false;
        pointerId = null;
        el.classList.remove('is-dragging');
        el.style.scrollBehavior = prevScrollBehavior || '';
      };

      el.addEventListener('pointerdown', onPointerDown);
      el.addEventListener('pointermove', onPointerMove, { passive: false });
      el.addEventListener('pointerup', endDrag);
      el.addEventListener('pointercancel', endDrag);
      el.addEventListener('pointerleave', endDrag);

      // Prevent accidental click while dragging.
      el.addEventListener(
        'click',
        function (evt) {
          if (moved) {
            evt.preventDefault();
            evt.stopPropagation();
            moved = false;
          }
        },
        true
      );
    },

    loadLottieAnimation: function (lottieEl, url) {
      var self = this;

      fetch(url, { credentials: 'same-origin' })
        .then(function (response) {
          if (!response.ok) {
            throw new Error('Lottie fetch failed: ' + response.status);
          }
          return response.json();
        })
        .then(function (animationData) {
          lottieEl.innerHTML = '';
          var anim = lottie.loadAnimation({
            container: lottieEl,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            animationData: animationData,
          });
          anim.addEventListener('DOMLoaded', function () {
            self.container.classList.add('diagnox-product-hero--lottie-ready');
          });
        })
        .catch(function () {
          /* Fallback: path-based load (older CDN links) */
          lottie.loadAnimation({
            container: lottieEl,
            renderer: 'svg',
            loop: true,
            autoplay: true,
            path: url,
          });
          self.container.classList.add('diagnox-product-hero--lottie-ready');
        });
    },

    initQuantity: function () {
      var input = this.container.querySelector('[data-dph-qty-input]');
      var minus = this.container.querySelector('[data-dph-qty-minus]');
      var plus = this.container.querySelector('[data-dph-qty-plus]');
      var display = this.container.querySelector('[data-dph-qty-display]');
      if (!input) return;

      var sync = function () {
        if (display) display.textContent = input.value;
      };

      if (minus) {
        minus.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 1;
          input.value = Math.max(1, val - 1);
          sync();
        });
      }

      if (plus) {
        plus.addEventListener('click', function () {
          var val = parseInt(input.value, 10) || 1;
          input.value = val + 1;
          sync();
        });
      }
    },

    initVariants: function () {
      var variantJson = this.container.querySelector('[data-variant-json]');
      if (!variantJson || typeof theme === 'undefined' || !theme.Variants) return;

      var variantsObject = JSON.parse(variantJson.textContent);
      var dynamicEl = this.container.querySelector('[data-dynamic-variants-enabled]');

      this.variants = new theme.Variants({
        container: this.container,
        enableHistoryState: true,
        singleOptionSelector: '[data-variant-input]',
        originalSelectorId: '[data-product-select]',
        variants: variantsObject,
        dynamicVariantsEnabled: !!dynamicEl,
      });

      this.container.addEventListener('variantPriceChange', this.onPriceChange.bind(this));
      this.container.addEventListener('variantChange', this.onVariantChange.bind(this));
      this.onVariantChange();
    },

    onPriceChange: function (evt) {
      var variant = evt.detail.variant;
      var priceEl = this.container.querySelector('[data-product-price]');
      if (!variant || !priceEl || typeof theme === 'undefined') return;
      priceEl.textContent = theme.Currency.formatMoney(
        variant.price,
        theme.settings.moneyFormat
      );
    },

    onVariantChange: function () {
      var buttons = this.container.querySelectorAll('[data-dph-variant-label]');
      var inputs = this.container.querySelectorAll('[data-variant-input]:checked');
      buttons.forEach(function (btn) {
        btn.classList.remove('is-selected');
      });
      inputs.forEach(
        function (input) {
          var label = this.container.querySelector('label[for="' + input.id + '"]');
          if (label) label.classList.add('is-selected');
        }.bind(this)
      );
    },

    initForm: function () {
      var form = this.container.querySelector('.diagnox-product-hero__form');
      if (!form || typeof theme === 'undefined' || !theme.AjaxProduct) return;

      new theme.AjaxProduct(form, '[data-add-to-cart]', {
        scopedEventId: 'DiagnoxProductHero-' + this.sectionId,
      });

      this.container.addEventListener('variantChange', function (evt) {
        var variant = evt.detail.variant;
        var btn = form.querySelector('[data-add-to-cart]');
        var btnText = form.querySelector('[data-add-to-cart-text]');
        if (!btn || !btnText) return;

        if (variant && variant.available) {
          btn.disabled = false;
          btnText.textContent =
            btnText.getAttribute('data-default-text') || btnText.textContent;
        } else if (variant) {
          btn.disabled = true;
          btnText.textContent = theme.strings.soldOut;
        }
      });
    },
  };

  function findHeroRoot(el) {
    if (!el) return null;
    if (el.getAttribute && el.getAttribute('data-section-type') === SECTION_TYPE) {
      return el;
    }
    return el.querySelector('[data-section-type="' + SECTION_TYPE + '"]');
  }

  function initSection(el) {
    var root = findHeroRoot(el);
    if (!root) return;
    if (root._dphInit) return;
    root._dphInit = true;
    root._dphHero = new DiagnoxProductHero(root);
  }

  function initAll(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-section-type="' + SECTION_TYPE + '"]').forEach(function (el) {
      initSection(el);
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    initAll();
  });

  document.addEventListener('shopify:section:load', function (evt) {
    var root = findHeroRoot(evt.target);
    if (root) {
      root._dphInit = false;
      root._dphHero = null;
      initSection(evt.target);
    } else {
      initAll(evt.target);
    }
  });
})();
